var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.8844 16.4599C31.8844 16.4599 30.5457 15.2215 28.4839 15.8467C26.5895 16.4178 26.1234 19.0268 27.4082 20.0428C28.1493 20.6259 29.2608 21.1068 30.7549 21.6358C34.1075 22.8261 32.8705 27.5813 29.4581 27.6053C28.1254 27.6113 27.5039 27.5272 26.3385 26.7577",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeMiterlimit: 13.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.458 14.0612V29.3427",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeMiterlimit: 13.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.8651 33.8223C45.5197 28.5958 46.7024 18.9323 41.5067 12.2383C36.311 5.54424 26.7044 4.35455 20.0498 9.58104C13.3952 14.8075 12.2125 24.471 17.4082 31.1651C22.6039 37.8591 32.2105 39.0488 38.8651 33.8223Z",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeMiterlimit: 13.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.4023 30.8937C34.472 32.3725 32.0696 33.2442 29.458 33.2442C23.1233 33.2442 17.9838 28.0742 17.9838 21.702C17.9838 19.0749 18.8563 16.6522 20.3264 14.7105",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeMiterlimit: 13.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.2368 12.0053C25.0297 10.839 27.1632 10.1597 29.458 10.1597C35.7927 10.1597 40.9323 15.3297 40.9323 21.702C40.9323 24.0224 40.251 26.1806 39.0796 27.9901",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeMiterlimit: 13.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.64898 51.1286V55.6433C8.64898 56.515 7.94977 57.2184 7.08323 57.2184H3.30031C2.43377 57.2184 1.73456 56.515 1.73456 55.6433V36.3522C1.73456 35.4805 2.43377 34.7771 3.30031 34.7771H7.08323C7.94977 34.7771 8.64898 35.4805 8.64898 36.3522V47.1971",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeMiterlimit: 13.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.64899 53.2567L18.928 57.8796C19.9439 58.2584 21.0256 58.4027 22.1013 58.2944L40.4183 56.503C41.5597 56.3888 42.6594 56.004 43.6156 55.3728L56.2611 47.0708C57.2771 46.1631 57.4623 44.6421 56.7034 43.512C55.8667 42.2736 54.1993 41.949 52.9623 42.7846L44.7988 46.8784C42.6474 47.9545 40.2928 48.5557 37.8964 48.6338L38.0039 46.9746C37.8067 44.9668 36.2708 43.3557 34.2868 43.0731L25.1671 42.0151C23.0635 41.7145 22.0117 41.0051 20.177 39.9291C17.673 38.4562 14.8224 37.6807 11.9239 37.6807H8.65496",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeMiterlimit: 13.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.3284 49.4153L37.9023 48.6338",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeMiterlimit: 13.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayIcon);
export default __webpack_public_path__ + "static/media/pay-icon.15ad7f37a3b4352b7350401da739d418.svg";
export { ForwardRef as ReactComponent };